import {
    STRIPE_CONNECTING,
    STRIPE_CONNECT_SUCCESS,
    STRIPE_CONNECT_FAILURE,
    STRIPE_STATUS_RECEIVED,
    STRIPE_STATUS_RECEIVING,
    STRIPE_DISCONNECT_SUCCESS,
    STRIPE_TIP_HISTORY_RECEIVED,
    STRIPE_TIP_HISTORY_RECEIVING
} from '../actions/stripe';

const defaultState = {
    // Map of userId → Stripe account info
    accounts: {},
    // Currently connecting userId
    connectingUserId: null,
    isConnecting: false,
    // Tip history
    tipHistory: [],
    tipTotalAmount: 0,
    tipTotalCount: 0,
    tipPage: 1,
    isLoadingTips: false,
    error: ""
};

export default function stripeReducer(state = defaultState, action) {
    switch (action.type) {
        case STRIPE_CONNECTING:
            return Object.assign({}, state, {
                isConnecting: true,
                connectingUserId: action.payload,
                error: ""
            });

        case STRIPE_CONNECT_SUCCESS:
            return Object.assign({}, state, {
                isConnecting: false,
                connectingUserId: null,
                accounts: Object.assign({}, state.accounts, {
                    [action.payload.userId]: {
                        stripeAccountId: action.payload.stripeAccountId,
                        stripeAccountStatus: 'pending',
                        tipPayoutEnabled: false,
                        onboardingUrl: action.payload.onboardingUrl,
                        accountLinkSource: action.payload.accountLinkSource || 'created_platform'
                    }
                })
            });

        case STRIPE_STATUS_RECEIVED:
            return Object.assign({}, state, {
                isConnecting: false,
                accounts: Object.assign({}, state.accounts, {
                    [action.payload.userId]: Object.assign(
                        {},
                        state.accounts[action.payload.userId] || {},
                        {
                            stripeAccountId: action.payload.stripeAccountId || (state.accounts[action.payload.userId] || {}).stripeAccountId,
                            stripeAccountStatus: action.payload.stripeAccountStatus || (state.accounts[action.payload.userId] || {}).stripeAccountStatus,
                            tipPayoutEnabled: action.payload.tipPayoutEnabled !== undefined
                                ? action.payload.tipPayoutEnabled
                                : ((state.accounts[action.payload.userId] || {}).tipPayoutEnabled || false),
                            payoutsEnabled: action.payload.payoutsEnabled,
                            chargesEnabled: action.payload.chargesEnabled,
                            accountLinkSource: action.payload.accountLinkSource !== undefined
                                ? action.payload.accountLinkSource
                                : (state.accounts[action.payload.userId] || {}).accountLinkSource
                        }
                    )
                })
            });

        case STRIPE_STATUS_RECEIVING:
            return Object.assign({}, state, {
                connectingUserId: action.payload
            });

        case STRIPE_DISCONNECT_SUCCESS:
            var updatedAccounts = Object.assign({}, state.accounts);
            delete updatedAccounts[action.payload.userId];
            return Object.assign({}, state, {
                isConnecting: false,
                connectingUserId: null,
                accounts: updatedAccounts
            });

        case STRIPE_CONNECT_FAILURE:
            return Object.assign({}, state, {
                isConnecting: false,
                connectingUserId: null,
                error: action.payload
            });

        case STRIPE_TIP_HISTORY_RECEIVING:
            return Object.assign({}, state, {
                isLoadingTips: true
            });

        case STRIPE_TIP_HISTORY_RECEIVED:
            return Object.assign({}, state, {
                isLoadingTips: false,
                tipHistory: action.payload.tips,
                tipTotalAmount: action.payload.totalAmount,
                tipTotalCount: action.payload.totalCount,
                tipPage: action.payload.page
            });

        default:
            return state;
    }
}
